// src/pages/MyConnections.js
import React from 'react';
import { Box, Grid, Typography, Container, Card, CardContent, CardActions, Button, Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import SidebarCard from '../components/connections/LeftSidebar';  // 引入左侧卡片
import SidebarRight from '../components/SidebarRight';

const MyConnections = () => {
    // 模拟一些推荐好友和我的好友数据
    const recommendedFriends = [
        {
            avatar: 'https://via.placeholder.com/40',
            name: '张三',
            position: '前端开发工程师',
            company: '六喜珠宝公司'
        },
        {
            avatar: 'https://via.placeholder.com/40',
            name: '李四',
            position: '后端开发工程师',
            company: '文思海辉金融'
        },
    ];

    const myFriends = [
        {
            avatar: 'https://via.placeholder.com/40',
            name: '王五',
            position: '全栈开发工程师',
            company: '爱立信'
        },
        {
            avatar: 'https://via.placeholder.com/40',
            name: '赵六',
            position: '产品经理',
            company: 'Bitget'
        },{
            avatar: 'https://via.placeholder.com/40',
            name: '王五',
            position: '全栈开发工程师',
            company: '爱立信'
        },
        {
            avatar: 'https://via.placeholder.com/40',
            name: '赵六',
            position: '产品经理',
            company: 'Bitget'
        },{
            avatar: 'https://via.placeholder.com/40',
            name: '王五',
            position: '全栈开发工程师',
            company: '爱立信'
        },
        {
            avatar: 'https://via.placeholder.com/40',
            name: '赵六',
            position: '产品经理',
            company: 'Bitget'
        },{
            avatar: 'https://via.placeholder.com/40',
            name: '王五',
            position: '全栈开发工程师',
            company: '爱立信'
        },
        {
            avatar: 'https://via.placeholder.com/40',
            name: '赵六',
            position: '产品经理',
            company: 'Bitget'
        },
    ];

    return (
        <Container maxWidth="lg" sx={{ marginTop: 4,"margin-bottom":"120px" }}>
            <Grid container spacing={2}>
                {/* 左侧卡片 */}
                <Grid item xs={12} sm={3}>
                    <SidebarCard />
                    {/* 左侧好友推荐 */}
                    <Grid >
                        <Typography variant="h6" gutterBottom>好友推荐</Typography>
                        <Box>
                            {recommendedFriends.map((friend, index) => (
                                <Card key={index} sx={{ marginBottom: 2 }}>
                                    <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Avatar src={friend.avatar} />
                                        <Box sx={{ marginLeft: 2 }}>
                                            <Typography variant="subtitle1">{friend.name}</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {friend.position} - {friend.company}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                    <CardActions>
                                        <Button size="small">添加好友</Button>
                                    </CardActions>
                                </Card>
                            ))}
                        </Box>
                    </Grid>

                </Grid>
                {/* 右侧的候选人推荐内容 */}
                <Grid item xs={12} md={6}>
                    <Box >
                        <Typography variant="h6" gutterBottom>我的好友</Typography>
                        <Card>
                            <List>
                                {myFriends.map((friend, index) => (
                                    <ListItem key={index} sx={{ marginBottom: 2 }}>

                                        <ListItemAvatar>
                                            <Avatar src={friend.avatar} />
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={friend.name}
                                            secondary={`${friend.position} - ${friend.company}`}
                                        />
                                        <Button variant="outlined" size="small">发送消息</Button>
                                        <Button variant="outlined" size="small" color="error" sx={{ marginLeft: 1 }}>删除好友</Button>
                                    </ListItem>
                                ))}
                            </List>
                        </Card>
                    </Box>
                    {/* 更多候选人推荐 */}
                    <Button sx={{ marginTop: 2 }}>显示全部</Button>
                </Grid>

                {/* 右侧栏 */}
                <Grid item xs={12} md={3}>
                    <SidebarRight />
                </Grid>
            </Grid>
        </Container>
    );
};

export default MyConnections;